import { useState } from "react";
import { NavLink, Outlet } from "react-router-dom";
import { useAuth } from "../../auth/AuthContext";

const NAV = [
  { to: "/", label: "Panel", icon: "📊", end: true },
  { to: "/cuotas", label: "Cuotas y pagos", icon: "💳" },
  { to: "/alumnos", label: "Alumnos", icon: "🧒" },
  { to: "/carga-masiva", label: "Carga masiva", icon: "⬆️" },
  { to: "/apoderados", label: "Apoderados", icon: "👪" },
  { to: "/cursos", label: "Cursos", icon: "🏅" },
  { to: "/gastos", label: "Gastos", icon: "🧾" },
  { to: "/configuracion", label: "Configuración", icon: "⚙️" },
];

export function AdminLayout() {
  const { profile, logout } = useAuth();
  const [open, setOpen] = useState(false);

  return (
    <div className="min-h-screen lg:flex">
      {/* Sidebar */}
      <aside
        className={`fixed inset-y-0 left-0 z-40 w-64 transform border-r border-slate-200 bg-white transition-transform lg:static lg:translate-x-0 ${
          open ? "translate-x-0" : "-translate-x-full"
        }`}
      >
        <div className="flex items-center gap-2 px-5 py-5">
          <span className="grid h-9 w-9 place-items-center rounded-xl bg-brand-600 text-lg">🏐</span>
          <span className="font-extrabold text-slate-800">Academia</span>
        </div>
        <nav className="space-y-1 px-3">
          {NAV.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              end={item.end}
              onClick={() => setOpen(false)}
              className={({ isActive }) =>
                `flex items-center gap-3 rounded-xl px-3 py-2 text-sm font-medium transition ${
                  isActive ? "bg-brand-50 text-brand-700" : "text-slate-600 hover:bg-slate-100"
                }`
              }
            >
              <span>{item.icon}</span>
              {item.label}
            </NavLink>
          ))}
        </nav>
      </aside>

      {open && (
        <div className="fixed inset-0 z-30 bg-slate-900/30 lg:hidden" onClick={() => setOpen(false)} />
      )}

      {/* Main */}
      <div className="flex-1">
        <header className="sticky top-0 z-20 flex items-center justify-between border-b border-slate-200 bg-white/80 px-4 py-3 backdrop-blur lg:px-8">
          <button className="btn-ghost lg:hidden" onClick={() => setOpen(true)}>
            ☰
          </button>
          <div className="hidden lg:block" />
          <div className="flex items-center gap-3">
            <div className="text-right">
              <p className="text-sm font-semibold text-slate-700">{profile?.nombre}</p>
              <p className="text-xs text-slate-400">Administrador</p>
            </div>
            <button className="btn-ghost" onClick={() => logout()}>
              Salir
            </button>
          </div>
        </header>

        <main className="mx-auto max-w-6xl px-4 py-6 lg:px-8">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
